import React, { useMemo } from 'react';

import { RouteComponentProps } from 'react-router';
import { Portal } from '@bringg-frontend/bringg-web-infra';

import { FilterBarManagerWithInitialData } from './filter-bar-manager-with-initial-data';
import { useStores } from '../../recipes';
import { ViewNames } from './filter-bar';

interface FilterBarPortalProps extends RouteComponentProps<{ path: ViewNames }> {}

const FilterBarPortal = React.memo<FilterBarPortalProps>(
	function FilterBarPortal(props: FilterBarPortalProps) {
		const { path } = props.match;
		const { planningStore, dispatchStore } = useStores();
		const activeStore = useMemo(() => (path === '/planning' ? planningStore : dispatchStore), [path]);

		return (
			<Portal
				element={<FilterBarManagerWithInitialData path={path} filterStore={activeStore} />}
				nodeId="filter-bar-portal"
			/>
		);
	},
	(prev, next) => {
		// Don't rerender on search params changes as this would cause the filtering to flicker
		return prev.match.path === next.match.path;
	}
);

export default FilterBarPortal;
